import { render } from "./Shipment.vue?vue&type=template&id=1e6914a3&scoped=true&ts=true"
import script from "./Shipment.vue?vue&type=script&lang=ts"
export * from "./Shipment.vue?vue&type=script&lang=ts"

import "./Shipment.vue?vue&type=style&index=0&id=1e6914a3&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e6914a3"]])

export default __exports__